/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

    class SearchDeletedConversationListContoller implements ng.IComponentController {
        static $inject = [];

        public conversationFilter: string;
        public selectedConversation: MeevoMessengerConversation;
        public conversationsList: IDataMaintenanceInfiniteList;
        public conversationType: DeletedConversationStylesEnum;
        public onFilterChanged: (conversationFilter: string) => void;
        public conversationSelectCallback: ({ conversation: MeevoMessengerConversation }) => void;
        constructor() {
            if (!this.conversationType) this.conversationType = DeletedConversationStylesEnum.Client;
        }

        $onInit() { }

        private onSelectConversation(conversation: MeevoMessengerConversation): void {
            this.selectedConversation = conversation;
            if (this.conversationSelectCallback) this.conversationSelectCallback({ conversation })
        }
    }

    class SearchDeletedConversationListComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/searchDeletedConversationList/searchDeletedConversationList.template.html';
        controller = SearchDeletedConversationListContoller;
        controllerAs = 'vm';
        bindings = {
            conversationFilter: '=',            
            conversationsList: '=',
            conversationType: '<?',
            selectedConversation: '=',
            onFilterChanged: '&',
            conversationSelectCallback: '&?',
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('meevoMessengerSearchDeletedConversationList', new SearchDeletedConversationListComponent());

}

